import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
}));
